module.exports = __webpack_public_path__ + "static/media/people-simple-solid.cef5e9d1.svg";